import fetchApi from '../utilities/fetch/httpService'
import apiUrls  from '../utilities/consts/apiUrls'

// last_name, last_name, mobile, email

export const sendNewsletter = ({last_name, mobile, email}) =>
  fetchApi({url: apiUrls.newsletter_subscriber, body: {last_name, mobile, email}, method: 'POST'})
